import React from 'react';
import { ErrorMessageProps, ValidationErrorMessage } from './ValidationErrorMessage';

type ErrorMessagePropsWithFieldName = ErrorMessageProps & { name: string };
type ErrorMessageIdProps = {
    name: string;
    id?: string;
};

export const getErrorMessageComponent = ({
    id,
    name,
    meta,
    testId,
    withHtmlValidationWarning,
}: ErrorMessagePropsWithFieldName) => {
    const errorMessageId = getErrorMessageId({ name, id });

    return (
        <ValidationErrorMessage
            id={errorMessageId}
            meta={meta}
            testId={testId}
            withHtmlValidationWarning={withHtmlValidationWarning}
        />
    );
};

export const getErrorMessageId = ({ name, id }: ErrorMessageIdProps) => {
    const errorMessageId = id ?? name;
    // Bronson's ErrorMessage component appends `error-` to element id.
    return errorMessageId;
};

export const getInputErrorMessageComponentAndId = (props: ErrorMessagePropsWithFieldName) => {
    const errorErrorMessageId = getErrorMessageId(props);

    return {
        errorMessageComponent: getErrorMessageComponent(props),
        errorMessageId: `error-${errorErrorMessageId}`,
    };
};
